<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="13.5" height="13.5">
    <path d="M4.193 6.794l1.651 2.064L9.147 4.73" stroke-linecap="round" stroke-linejoin="round" fill="none" stroke="#57b574" stroke-width="1.5"/>
    <circle cx="6" cy="6" r="6" transform="translate(.75 .75)" fill="none" stroke="#57b574" stroke-width="1.5"/>
  </svg>
</template>
